import { defineStore } from 'pinia';

// types
import type { IBots, IRbResetFixOrder } from '../types';

// services
import StatsService from '@services/statsService';

export const useRbResetFixOrder = defineStore('rbResetFixOrder', {
    state: (): IRbResetFixOrder => ({
        loading: false,
        showModal: false,
        bots: [],
        stop_bot_after_fix_completed: false,
    }),
    getters: {
        hasStatusTrue(state) {
            return state.bots.some((el) => !!el.status);
        },
    },
    actions: {
        open(ids: number[]) {
            if (!ids?.length) return;

            ids.forEach(el => {
                this.bots.push({
                    id: el,
                    loading: false,
                    messages: [],
                    status: false,
                });
            });
          
            this.showModal = true;
        },
        close() {
            this.showModal = false;
        },
        reset() {
            this.$reset();
        },
        resetErrors() {
            this.bots.forEach(bot => {
                if (!bot.status) {
                    bot.messages.splice(0, 1);
                }
            });
        },
        async closeAtMarket() {
            this.resetErrors();
            this.loading = true;

            for (const bot of this.bots) {
                if (!bot.status) {
                    await this.resetFixOrder(bot);
                }
            }

            this.loading = false;
        },
        async resetFixOrder(bot: IBots) {
            bot.loading = true;
                
            const payload = {
                _formPath: 'closeAtMarket',
                id: bot.id,
                market: true,
                stop_bot_after_fix_completed: this.stop_bot_after_fix_completed,
            };
            const prepare: IResetFixOrderResponse = await StatsService.resetFixOrder(payload);

            bot.status = prepare.data.status;
              
            if (prepare) {
                // show messages
                if (prepare.postMessages) {
                    prepare.postMessages.forEach(el => {
                        bot.messages.push(el);
                    });
                }

                if (prepare.data.errors) {
                    prepare.data.errors.forEach(el => {
                        bot.messages.push({
                            success: false,
                            msg: el.msg,
                        });
                    });
                }
            }

            bot.loading = false;
        },
    },
});